import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TasksService } from '@compumark/analyst-selection-tool-client';
import { PreviewValidationComponent } from '../preview-validation/preview-validation.component';

@Component({
  selector: 'app-preview-logo-renderer',
  standalone: false,
  templateUrl: './preview-logo-renderer.component.html',
})
export class PreviewLogoRendererComponent {
  params: any;

  constructor(
    private tasksService: TasksService,
    private matdialog: MatDialog,
  ) {}

  agInit(params: any): void {
    this.params = params;
  }

  requestPreview(): void {
    this.tasksService
      .validatePreviewSearchRequest(
        this.params.data.productionOrderIdentifier.prodOrderNo,
        this.params.data.productionOrderIdentifier.prodOrderSeqNo,
      )
      .subscribe((results) => {
        if (!results) {
          this.matdialog.open(PreviewValidationComponent, {
            autoFocus: false,
          });
        } else {
          window.open(
            `task/${this.params.data.id}/preview-search/${this.params.data.productionOrderIdentifier.prodOrderNo}/${this.params.data.productionOrderIdentifier.prodOrderSeqNo}`,
            '_blank',
          );
        }
      });
  }
}
